import { call, put, takeLatest, select } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'

import * as Constants from './constants'
import * as brActions from './actions'
const getPermissionRoleState = state => state.permissionRole;

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}

function listRequestApi(formData) {
  const request = axiosApi().post(
    Constants.PERMISSION_ROLE_LIST_API,
    formData
  )

  return handleRequest(request);
}

function detailRequestApi(formData) {
  const request = axiosApi().post(
    Constants.PERMISSION_ROLE_DETAIL_API,
    formData
  )

  return handleRequest(request);
}

function permissionRoleUpdateRequestApi(formData) {
  const request = axiosApi().post(
    Constants.PERMISSION_ROLE_UPDATE_API,
    formData
  )

  return handleRequest(request);
}

function* permissionRoleListRequestFlow() {
  const permissionRole = yield select(getPermissionRoleState);
  try {
    // grab the client from our action
    const results = yield call(listRequestApi, permissionRole.formData)

    // dispatch the action with our widgets!
    yield put(brActions.permissionRoleListSuccess(results.data))

  } catch (error) {
    yield put(brActions.permissionRoleListError(error))
  }
}

function* permissionRoleDetailRequestFlow() {
  const permissionRole = yield select(getPermissionRoleState);
  try {
    // grab the client from our action
    const results = yield call(detailRequestApi, permissionRole.formData)

    // dispatch the action with our widgets!
    yield put(brActions.permissionRoleDetailSuccess(results.data))

  } catch (error) {
    yield put(brActions.permissionRoleDetailError(error))
  }
}

function* permissionRoleUpdateRequestFlow() {
  const permissionRole = yield select(getPermissionRoleState);
  try {
    // grab the client from our action
    const result = yield call(permissionRoleUpdateRequestApi, permissionRole.formData)

    // dispatch the action with our widgets!
    yield put(brActions.permissionRoleUpdateSuccess(result));
    if (typeof callback == 'function') {
      permissionRole.callback(results);
    }
  } catch (error) {
    yield put(brActions.permissionRoleUpdateError(error))
  }
}

function* permissionRoleWatcher() {
  yield [
    takeLatest(Constants.PERMISSION_ROLE_LIST_REQUESTING, permissionRoleListRequestFlow),
    takeLatest(Constants.PERMISSION_ROLE_DETAIL_REQUESTING, permissionRoleDetailRequestFlow),
    takeLatest(Constants.PERMISSION_ROLE_UPDATE_REQUESTING, permissionRoleUpdateRequestFlow),
  ]
}

export default permissionRoleWatcher



// WEBPACK FOOTER //
// ./src/views/PermissionRole/sagas.js